import { IconBase } from "./iconBase.js";
import { jsx } from "@emotion/react/jsx-runtime";
//#region src/line.tsx
var Line = ({ ...rest }) => /* @__PURE__ */ jsx(IconBase, {
	viewBox: "0 0 24 24",
	...rest,
	children: /* @__PURE__ */ jsx("line", {
		x1: "6.5",
		y1: "16.7531",
		x2: "16.753",
		y2: "6.50001",
		stroke: "currentColor",
		strokeWidth: "1.5",
		strokeLinecap: "round"
	})
});
//#endregion
export { Line };
